<template>
  <div class="ctn">
    <div calss="sess-list" v-show="!displayInvalid">
      <el-radio-group v-model="defaultSession">
        <el-radio v-for="shell in shellList" :key="shell" :label="shell" style="width: 40%; padding: 0.3em 1em 0.3em 0;">{{ shell }}</el-radio>
      </el-radio-group>
    </div>
    <div class="invalid" v-show="displayInvalid">
      There is no session to be set!
    </div>
  </div>
</template>

<script>
export default {
  name: "confSessionDefault",
  data() {
    return {
      displayInvalid: false,
      shellList: [],
      defaultSession: null,
    }
  },
  mounted() {
    this.updateShellList()
  },
  watch: {
    defaultSession: function() {
      this.utils.conf.saveLocalSessDefault(this.defaultSession)
    }
  },
  methods: {
    updateShellList() {
      let self = this
      this.api.shell.getShellList((error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }

        if (!data || data.length < 1) {
          self.displayInvalid = true
        }
        
        self.shellList = data
        self.defaultSession = self.utils.conf.loadLocalSessDefault()
      });
    },
  }
}
</script>

<style scoped>
.ctn {
  text-align: left;
}
.sess-list {
  display: flex;
  justify-content: start;
}
.invalid {
  display: flex;
  justify-content: center;
}
</style>